import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PMT_PROVIDER_REQUEST: '',
  GET_PMT_PROVIDER_SUCCESS: '',
  GET_PMT_PROVIDER_FAILURE: '',

  POST_PAIN_MGMT_REQUEST: '',
  POST_PAIN_MGMT_SUCCESS: '',
  POST_PAIN_MGMT_FAILURE: '',

  VALIDATE_PAIN_MGMT_REQUEST: '',
  VALIDATE_PAIN_MGMT_SUCCESS: '',
  VALIDATE_PAIN_MGMT_FAILURE: '',
};

types = setStoreTypeValues(types, 'authPMTProv');

export default types;
